import { MODAL_PRICING } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import { OptionalMain } from './OptionalMain'

export const Pricing: React.FC = () => {
  const dispatch = useDispatch()
  const [params] = useSearchParams()

  useEffect(() => {
    const modalProps = params.has('monthly') ? { planType: 'monthly' } : null
    // @ts-expect-error
    dispatch(openModal(MODAL_PRICING, modalProps))
  }, [])

  return <OptionalMain />
}
